import { useQuery } from '@tanstack/react-query';
import { getCourseHasSimulationWeek } from '../../../core/queries/course';

function useCourseHasSimulationWeek(courseSlug: string, programId: string) {
  const { data, isError, error, isSuccess, isPending } = useQuery({
    queryKey: ['fetch-program', courseSlug, programId],
    queryFn: () => getCourseHasSimulationWeek(courseSlug, programId),
    refetchOnWindowFocus: false,
    retry: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
  };
}

export { useCourseHasSimulationWeek };
